import React from 'react'
import MCBanner from '@mc/banner'
import { usePrimaryCta } from '@mc/growth'
import { useTranslation, withI18nContext } from '@mc/i18n'
import { usePromotion } from '@mc/promo-utils'
import { i18nInstance } from '../../i18n/i18nInstance'
import { PROMO_I18N_NAMESPACE } from '../../lib/constants'
import { trackBannerCTAClick, trackBannerOnClose } from '../../lib/events'
import { UrgencyTextGreen } from '../featureVariables'
import { BannerContent } from './BannerContent'
import { BannerPromoText } from './BannerPromoText'
import { getBannerPropsByPath } from './getPathBannerProps'
import classes from './Banner.module.scss'

const BannerProvided = withI18nContext(i18nInstance)(({
  pathname,
}: BannerProps) => {
  const { t } = useTranslation(PROMO_I18N_NAMESPACE)
  const { ctaHref, ctaCopy } = usePrimaryCta()
  const { isDark, hideCta } = getBannerPropsByPath(pathname)

  const onClose = () => trackBannerOnClose()
  const onCtaClick = () => {
    trackBannerCTAClick({ action: ctaCopy, href: ctaHref })
  }

  return (
    <MCBanner
      theme={isDark ? 'dark' : 'light'}
      isClosable
      onClose={onClose}
      aria-label={t('common.promoBanner.a11y')}
      closeBtnClassName={classes.close}
      className='mc-mb-2'
    >
      <BannerContent>
        <BannerContent.Title>
          <BannerPromoText />
        </BannerContent.Title>

        <BannerContent.Subtitle>
          <UrgencyTextGreen />
        </BannerContent.Subtitle>

        {hideCta ? null : (
          <BannerContent.CTA ctaHref={ctaHref} onCtaClick={onCtaClick}>
            {ctaCopy}
          </BannerContent.CTA>
        )}
      </BannerContent>
    </MCBanner>
  )
})

export type BannerProps = {
  pathname: string
  isGift?: boolean
}

export const Banner = ({ pathname, isGift }: BannerProps) => {
  const { isPromotionOn } = usePromotion({ isGift })

  if (!isPromotionOn) {
    return null
  }

  return <BannerProvided pathname={pathname} />
}
